import { render } from "./PopUpView.vue?vue&type=template&id=dc52a1da&scoped=true"
import script from "./PopUpView.vue?vue&type=script&lang=js"
export * from "./PopUpView.vue?vue&type=script&lang=js"

import "./PopUpView.vue?vue&type=style&index=0&id=dc52a1da&scoped=true&lang=css"

import exportComponent from "/Users/jeongyunl/Documents/GitHub/datamap-search/vue-for-django/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc52a1da"]])

export default __exports__